import * as React from "react";
import { Grid, Tab, TabProps, Card } from "semantic-ui-react";
import { OrgStructure } from "@teamprevent/common/orgStructure/models";
import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { CustomerUserDetailModel, AppState } from "../model";
import { customerUserSelector, basePathSelector, routeIdSelector } from "../selectors";
import { loadCustomerUserDetail } from "../actions";

import * as details from "./details";

import { push } from "redux-little-router";

export interface CoreDetailProps {
    customerUser: CustomerUserDetailModel;
    orgStructures: OrgStructure[];
}

export interface DetailProps extends CoreDetailProps {
    path: string;
    basePath: string;
    tab?: string;
}

export const Detail = () => {
    const path = useSelector((state: AppState) => state.router.pathname);
    const basePath = useSelector(basePathSelector);
    const currentTab = useSelector((state: AppState) => state.router.pathname.substring(
        basePathSelector(state).length + 1 + routeIdSelector(state).toString().length));
    const customerUser = useSelector(customerUserSelector);
    const orgStructures = useSelector((state: AppState) => state.orgStructures);

    const detailProps = React.useMemo(() => ({
        path,
        basePath,
        tab: currentTab,
        customerUser,
        orgStructures,
    }), [path, basePath, currentTab, customerUser, orgStructures]);

    const tabs = React.useMemo(() => (Object.keys(details) as (keyof typeof details)[]).map(k => details[k]), []);
    const panes = React.useMemo(() => tabs.map(t => t(detailProps)), [tabs, detailProps]);

    const dispatch = useDispatch();

    const customerUserId = useSelector((state: AppState) => state.router.params?.customerUserId);

    React.useEffect(() => {
        dispatch(loadCustomerUserDetail({ customerUserId }));
    }, [dispatch, customerUserId]);

    const activeIndex = panes.slice(1).findIndex(p => currentTab && currentTab.startsWith(p.path)) + 1;

    const handleTabChange = React.useCallback(({ index }: TabProps) => {
        dispatch(push(`${basePath}/${customerUser.id}${tabs[index as unknown as number](undefined).path}`));
    }, [dispatch, basePath, customerUser.id, tabs]);

    const content = () => panes.length === 1
        ? <Card className="not-tabular" fluid>{panes[0].render()}</Card>
        : <Tab panes={panes} onTabChange={handleTabChange} activeIndex={activeIndex} />;

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column>
                    <h1>{customerUser.firstName}</h1>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    {content()}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
